<script setup lang="ts">
// PROPS
interface Props {
    appliedFilters: AppliedFilter[];
}

defineProps<Props>();
</script>

<template>
    <div v-if="appliedFilters.length" class="flex flex-wrap gap-1 p-4">
        <SlpAppliedFilterBadges :applied-filters="appliedFilters" />
    </div>
</template>
